// JsFromRoutes CacheKey b30a075a170594255995d752daca6ade
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/v1/foods'),
  autocomplete: /* #__PURE__ */ definePathHelper('get', '/api/v1/foods/autocomplete'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/v1/foods'),
}
